var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1471 0.955078C5.05712 0.955078 0.102539 5.90966 0.102539 11.9997C0.102539 18.0897 5.05712 23.0443 11.1471 23.0443C17.2372 23.0443 22.1918 18.0897 22.1918 11.9997C22.1918 5.90966 17.2372 0.955078 11.1471 0.955078ZM12.071 16.8921C12.071 17.4139 11.648 17.837 11.1262 17.837C10.6043 17.837 10.1813 17.4139 10.1813 16.8921V16.7661C10.1813 16.2443 10.6043 15.8212 11.1262 15.8212C11.648 15.8212 12.071 16.2443 12.071 16.7661V16.8921ZM12.071 12.9446C12.071 13.4664 11.648 13.8894 11.1262 13.8894C10.6043 13.8894 10.1813 13.4664 10.1813 12.9446V7.10727C10.1813 6.58542 10.6043 6.16238 11.1262 6.16238C11.648 6.16238 12.071 6.58542 12.071 7.10727V12.9446Z",
    fill: "#E9655B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e17f7c9897522b1b36494ca4dc6adbad.svg";
export { ForwardRef as ReactComponent };